export const KEY_DOWN = 'keydown';
export const MOUSE_DOWN = 'mousedown';
